import React, { useContext } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { MAIN_CONTAINER_ID } from '../../../constants';
import { DeviceContext } from '../../../contexts';
import { ChangeLog } from '../../../types';
import { ChangeHistoryTable } from './ChangeHistoryTable';

interface Props {
  open: boolean;
  handleClose: Function;
  logs?: ChangeLog[];
}

export const ProcessingPaymentChangeLogDialog: React.FC<Props> = ({ open, handleClose, logs }) => {
  const { isMobile } = useContext(DeviceContext);

  return (
    <Dialog
      fullScreen={isMobile}
      maxWidth="md"
      fullWidth
      container={document.getElementById(MAIN_CONTAINER_ID)}
      open={open}
      onClose={() => handleClose()}
    >
      <DialogTitle>Changes History</DialogTitle>

      <DialogContent>
        <Box paddingTop={1}>
          <ChangeHistoryTable logs={logs || []} fields={['business_type']} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button style={{ width: 106 }} size="large" variant="outlined" onClick={() => handleClose()}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
